import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject, ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { KENDO_GRID, GridSize } from '@progress/kendo-angular-grid';
import { KENDO_SVGICON } from '@progress/kendo-angular-icons';
import { KENDO_BREADCRUMB } from '@progress/kendo-angular-navigation';
import { saveIcon, fileExcelIcon, editToolsIcon, plusIcon, uploadIcon } from '@progress/kendo-svg-icons';
import { LayoutModule } from "@progress/kendo-angular-layout";
import { InputsModule, TextBoxComponent } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { KENDO_DROPDOWNS } from "@progress/kendo-angular-dropdowns";
import { FormControl, FormsModule, FormBuilder, FormGroup, ReactiveFormsModule, Validators, EmailValidator } from '@angular/forms';
import { DropDownListModule } from '@progress/kendo-angular-dropdowns';
import { PortalObjectsService } from '../../../_services/portal-objects.service';
import { process } from '@progress/kendo-data-query';
import { KENDO_SPREADSHEET } from "@progress/kendo-angular-spreadsheet";
import { DialogService, DialogsModule } from '@progress/kendo-angular-dialog';
import { SVGIcon, xIcon, gearIcon, changeManuallyIcon, copyIcon, questionCircleIcon } from '@progress/kendo-svg-icons';
import { Companies, Users, Projects, emptyProjects } from '../../../_models/admin';
import { PortalAdminService } from '../../../_services/portal-admin.service';
import { MsalService } from '@azure/msal-angular';
import {
  KENDO_NOTIFICATION,
  NotificationRef,
  NotificationService,
  NotificationSettings,
} from "@progress/kendo-angular-notification";

@Component({
    selector: 'app-projects',
    imports: [KENDO_SVGICON, KENDO_BUTTON, KENDO_GRID, KENDO_BREADCRUMB, KENDO_NOTIFICATION, KENDO_DROPDOWNS, KENDO_SPREADSHEET,
        DialogsModule,
        LayoutModule, CommonModule, DropDownListModule, InputsModule, LabelModule, FormsModule, ReactiveFormsModule
    ],
    templateUrl: './projects.component.html',
    styleUrl: './projects.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})
export class ProjectsComponent {
  portalObjectService = inject(PortalObjectsService);
  portalAdminService = inject(PortalAdminService);
  adminProjects: Projects[] = [];
  adminUser!: Users;
  displayProjects: Projects[] = [];
  selection: any[] = [];
  adminCompanies: Companies[] = [];
  companiesLoading: boolean = false;
  loading: boolean = false;
  buttonshidden: boolean = false;
  addbuttonstate: boolean = false;
  removebuttonstate: boolean = true;
  savebuttonstate: boolean = true;
  uploadbuttonstate: boolean = false;
  readonly: boolean = false;
  searchTerm: string = '';
  selectedRowItem: any[] = [];
  pageSize: number = 30;
  initialFormValues!: Projects;
  showErrorDialog: boolean = false;
  errorMessage: string = '';
  excelSVG: SVGIcon = fileExcelIcon;
  public iconNames: SVGIcon[] = [plusIcon, xIcon, saveIcon, uploadIcon, gearIcon, editToolsIcon, copyIcon, changeManuallyIcon, questionCircleIcon];

  public smallSize: GridSize = 'small';
  locations = ['US Test', 'US Production', 'EU Production'];
  selectedLocation: string = '';


  constructor(

    private formBuilder: FormBuilder,
    private notificationService: NotificationService,
    private dialogService: DialogService,
    private authService: MsalService,
    private cdr: ChangeDetectorRef
  ) {

  }

  ngOnInit(): void {

    this.getAdminProjects();
    this.buildform();

  }

  public form: FormGroup = new FormGroup({
    projectid: new FormControl(),
    projectname: new FormControl(),
    projectnumber: new FormControl(),
    idocs_project_nmuber: new FormControl(),
    location: new FormControl(null, { nonNullable: false }),
    idocs_project_id: new FormControl(),
    active: new FormControl(true),

  });

  public onFilter(inputValue: string): void {
    this.searchTerm = inputValue;
    this.form.reset();
    this.selection = [];
    this.form.disable();
    this.buttonhandle('Filter');

    this.displayProjects = process(this.adminProjects, {
      filter: {
        logic: 'or',
        filters: [
          {
            field: 'projectname',
            operator: 'contains',
            value: inputValue,
          },
          {
            field: 'projectnumber',
            operator: 'contains',
            value: inputValue,
          },

        ],
      },
    }).data;

  }
  buildform() {
    this.form.enable();
    this.form = this.formBuilder.group({
      projectid: null,
      projectname: ['', [Validators.required, Validators.minLength(2)]],
      projectnumber: ['', [Validators.required, Validators.minLength(2)]],
      idocs_project_number: [''],
      location: '',
      idocs_project_id: [{ value: '', disabled: true }],
      active: true,
    });
    this.form.disable();
  }

  public showError(value: string): void {
    this.notificationService.show({
      content: value,

      hideAfter: 10000,
      position: { horizontal: "right", vertical: "top" },
      animation: { type: "slide", duration: 400 },
      type: { style: "error", icon: true },
    });
  }

  buttonhandle(action: string) {
    this.addbuttonstate = true;
    this.removebuttonstate = true;
    this.savebuttonstate = true;
    // this.uploadbuttonstate = false;
    if (action === 'Click') {
      this.addbuttonstate = false;
      this.removebuttonstate = false;
    }

    if (action === 'Filter') {
      this.addbuttonstate = false;
    }
    if (action === 'Remove') {
      this.addbuttonstate = false;
    }

    if (action === 'Save') {
      this.addbuttonstate = false;

    }
    if (action = 'Upload') {
      this.uploadbuttonstate = true;
    }

  }

  getAdminProjects() {
    this.loading = true;
    this.adminProjects = [];
    this.form.reset();

    this.portalAdminService.getProjects().subscribe({
      next: (result) => {
        this.adminProjects = result;
        this.cdr.markForCheck();
      },
      error: (error) => {
        //throw message of some sort
        console.log(error)
        this.loading = false;
      },
      complete: () => {
        this.displayProjects = this.adminProjects;
        this.loading = false;
        this.selection = this.selectedRowItem;
        this.form.disable();
        // console.log(JSON.stringify(this.adminUsers));
      }
    });
  }

  onCellClick(event: any) {
    this.form.reset();
    this.form.enable();
    console.log(event);

    //    // this.selectedItem.value[id];
    let remark = event.dataItem.remarks;
    if (remark === null) {
      remark = '';
    }

    let active = true;
    if (event.dataItem.active === 'F') {
      active = false;

    }
    this.form = this.formBuilder.group({
      projectid: event.dataItem.projectId,
      projectname: [event.dataItem.projectname, [Validators.required, Validators.minLength(2)]],
      projectnumber: [event.dataItem.projectnumber, [Validators.required, Validators.minLength(2)]],
      idocs_project_number: [event.dataItem.idocs_project_number],
      idocs_project_id:  [event.dataItem.idocs_project_id, [Validators.required, Validators.minLength(2)]],
      location: [event.dataItem.location, [Validators.required, Validators.minLength(2)]],
      active: active,


    });

    //this.selectedItem=this.listItems[event.dataItem.usertype];

    this.initialFormValues = this.form.value;
    this.readonly = false;
    this.buttonhandle('Click');


  }
  valueChange(event: string) {
    this.formHasChanged();
  }

  idValueChange(event: string){
    this.formHasChanged();
  }

  locationChange(event: string){
    this.formHasChanged();
  }


  projectdata: Projects = emptyProjects();
  projectData(): Projects {
    console.log(this.form.value.createdBy)
    this.projectdata.projectId = this.form.value.id;
    this.projectdata.projectname = this.form.value.projectname;

    this.projectdata.projectnumber = this.form.value.projectnumber;
    this.projectdata.idocs_project_number = this.form.value.idocs_project_nmuber;
    this.projectdata.idocs_project_id = this.form.value.idocs_project_id;
    this.projectdata.location = this.form.value.location;
    if (this.form.value.active) {
      this.projectdata.active = 'T';
    } else {
      this.projectdata.active = 'F'
    }
    //  console.log(this.userdata);


    return this.projectdata;
  }

  adminProject: Projects = emptyProjects();

  onSaveButtonClick() {
    this.selectedRowItem = [];
    this.buttonhandle('Save');

    console.log(this.form.get('projectid')?.value);

    if (this.form.get('projectid')?.value == null) {
      this.portalAdminService.addProjects(this.projectData()).subscribe({
        next: (result) => {
          this.adminProject = result;
          this.cdr.markForCheck();
        },
        error: (error) => {
          //throw message of some sort
          console.log('Error :' + JSON.stringify(error.message))
          this.showError(JSON.stringify(error.message));
          this.loading = false;
        },
        complete: () => {
          //this.displayCompanies = this.adminCompanies;
          this.selectedRowItem = [this.adminProject.projectId];
          this.getAdminProjects();

          //console.log(JSON.stringify(this.adminCompany));
        }
      });
    } else {
      this.portalAdminService.updateProjects(this.form.get('projectid')?.value, this.projectData()).subscribe({
        next: (result) => {
          this.adminProject = result;
          this.cdr.markForCheck();
        },
        error: (error) => {
          console.log('Error :' + JSON.stringify(error.message))
          this.showError(JSON.stringify(error.message));
          this.loading = false;
        },
        complete: () => {
          //this.displayCompanies = this.adminCompanies;
          this.selectedRowItem = [this.adminProject.projectId];
          this.getAdminProjects();

          //console.log(JSON.stringify(this.adminCompany));
        }
      });
    }
  }

  onRemoveButtonClick() {
    const popupErrorMessages = [
      'Cannot delete project: it is currently in use by one or more users.'
    ];
    
    this.portalAdminService.deleteProject(this.form.get('projectid')?.value).subscribe({
      next: (result) => {
        this.adminProject = result;
        this.cdr.markForCheck();
      },
      error: (error) => {
        const backendMessage = error?.error?.message || 'An unexpected error occurred.';
        if (popupErrorMessages.includes(backendMessage)) {
          this.errorMessage = backendMessage;
          this.showErrorDialog = true;
          this.cdr.markForCheck();
        } else {
          this.showErrorDialog = false; 
          this.showError(backendMessage); // Show as red error
        }
        this.loading = false;
      },
      complete: () => {
        //this.displayCompanies = this.adminCompanies;
        this.selectedRowItem = [];
        this.getAdminProjects();
        this.buttonhandle('Remove');
        //console.log(JSON.stringify(this.adminCompany));
      }
    });
  }




  @ViewChild('projectnametext') projectnametext!: TextBoxComponent;
  onAddButtonClick() {

    // console.log('Add');
    this.buildform();
    this.form.enable();
    this.form.get('idocs_project_id')?.disable();   // <-- keep it disabled
    this.selection = [];
    this.buttonhandle('Add');
    this.initialFormValues = this.form.value;
    setTimeout(() => {
      this.projectnametext.focus();

    }, 100);

  }


  onUploadClick() {

  }

  projectEnabledChange(event: any) {
    this.form.patchValue({
      active: event.srcElement.checked
    });

    this.formHasChanged();
  }


  formHasChanged(): boolean {

    const checkvalue = Object.entries(this.initialFormValues).some(
      ([field, value]) => value !== this.form.value[field]
    );
    let projectname = this.form.get('projectname')?.value;
    let projectnumber = this.form.get('projectnumber')?.value;
    let idocsProjectId = this.form.get('idocs_project_id')?.value;
    let location = this.form.get('location')?.value;



    if (projectname != null && projectnumber != null && location != null && projectname.length > 1 && projectnumber.length > 1 && location.length > 1) {
      if (checkvalue) {
        this.savebuttonstate = false;
      } else {
        this.savebuttonstate = true;
      }
    }
    else {
      this.savebuttonstate = true;
    }

    return checkvalue;
  }
  getFileName() {
    let str = 'Portal Projects';
    return `${str} ${this.getFormattedDate()}.xlsx`
  }
  getFormattedDate(): string {
    const date = new Date();
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }


}
